/* Photographs cannot be right-clicked, dragged out of the page, or long-pressed to "Save image" on a phone.
   Owner's request, 2026-09-19. A deterrent against casual copying only: a screenshot still works, which is
   why every photograph also carries the watermark and the copyright in its file properties.
   Text stays selectable and ordinary links keep their menu. To switch it off, drop this script from the
   page — in the Shopify theme it becomes a tick box in the theme settings. */
(() => {
  const onPicture = e => e.target instanceof Element && e.target.closest('img, picture');

  document.addEventListener('contextmenu', e => { if (onPicture(e)) e.preventDefault(); });
  document.addEventListener('dragstart', e => { if (onPicture(e)) e.preventDefault(); });

  const style = document.createElement('style');
  style.textContent = 'img{-webkit-user-drag:none;user-select:none;-webkit-user-select:none;-webkit-touch-callout:none}';
  document.head.appendChild(style);
})();
